module.exports = __webpack_public_path__ + "static/media/ins15.7c443531.jpg";